import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { Pratica } from 'src/interfaces/pratica';
import { PersonaGiuridica } from '../applicant/models/persona-giuridica';
import { Product } from '../requests/models/product';
import { Channel } from '../settings/canals/channel';
import { ChannelService } from '../_core/services/channel.service';
import { PersonaGiuridicaService } from '../_core/services/persona-giuridica.service';
import { ProductService } from '../_core/services/product.service';
import { SharedModule } from '../_shared/shared.module';
import { TransferRecap } from './transfer-recap';

export interface DialogData {
  pratica: Pratica;
}

interface TransferInfo {
  voce: string;
  importo: number;
  causale: string;
  iban: string;
}

@Component({
  standalone: true,
  selector: 'app-transfers-recap',
  templateUrl: './transfers-recap.component.html',
  styleUrls: ['./transfers-recap.component.scss'],
  imports: [SharedModule],
})
export class TransfersRecapComponent {
  transferRecap: Partial<TransferRecap>[] = [];
  name: string = '';
  type: string = '';
  dataSource: TransferInfo[] = [];
  product: Partial<Product> = {};
  private readonly crescitaliaIban = 'IT23B0569601636000003326X51';
  displayedColumns: (keyof TransferInfo)[] = [
    'voce',
    'importo',
    'causale',
    'iban',
  ];
  recapColumns = ['property', 'value'];

  recapDataSource: { property: string; value: string }[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<
      TransfersRecapComponent,
      TransfersRecapComponent
    >,
    private channelService: ChannelService,
    private cdr: ChangeDetectorRef,
    private productService: ProductService,
    private pgService: PersonaGiuridicaService
  ) {
    this.name = this.data.pratica?.denomination;
    this.type = this.data.pratica?.target?.toUpperCase();
  }

  ngAfterViewInit() {
    if (this.data.pratica) {
      this.getTransferRecap(
        this.data.pratica.garante,
        this.data.pratica.erogante,
        this.data.pratica.id
      );
    }
  }

  getTransferRecap(garanteId: string, eroganteId: string, praticaId: string) {
    forkJoin([
      this.channelService.getByID(garanteId),
      this.channelService.getByID(eroganteId),
      this.productService.list(praticaId),
      this.getPersonaGiuridica(),
    ]).subscribe(([garante, erogante, products, personaGiuridica]) => {
      this.genTransfersTable(garante, erogante, products[0], personaGiuridica);
    });
  }

  private genTransfersTable(
    garanteChannel: Channel,
    eroganteChannel: Channel,
    product: Product | undefined,
    personaGiuridica: PersonaGiuridica
  ) {
    let trattConfGar: TransferInfo = {
      voce: 'Trattenute Confidi Erogante',
      importo: product?.commissioniErogazione || 0,
      causale: '/',
      iban: '/',
    };

    let netto: TransferInfo = {
      voce: 'Importo Netto da erogare da bonificare al cliente',
      importo: product?.nettoErogato || 0,
      causale: `Erogazione finanziamento CresciCONoi al netto delle spese della stipula contratto pratica n° ${this.data.pratica?.praticaCode} Spin`,
      iban: personaGiuridica.iban,
    };

    let importoGarante: TransferInfo = {
      voce: 'Importo da bonificare al Confidi Garante, comprensivo  delle commissioni Fondo Centrale',
      importo: product?.totaleCostoRilascioGaranzia || 0,
      causale: `Commissioni pratica n° ${this.data.pratica?.praticaCode}`,
      iban: garanteChannel.iban || '',
    };

    let importoMediazione: TransferInfo = {
      voce: 'Importo da bonificare a Crescitalia Mediazione Creditizia per le commissioni di mediazione',
      importo: product?.commissioniMediazioneNettoRitenuta || 0,
      causale: `Commissioni di mediazione pratica n° ${this.data.pratica?.praticaCode}`,
      iban: this.crescitaliaIban,
    };

    let speseTributarie: TransferInfo = {
      voce: ' Spese tributarie trattenute ',
      importo: 16,
      causale: `/`,
      iban: '/',
    };

    this.dataSource = [
      trattConfGar,
      netto,
      importoGarante,
      importoMediazione,
      speseTributarie,
    ];

    this.recapDataSource = [
      { property: 'CLIENTE', value: this.data.pratica?.denomination },
      { property: 'CONFIDI EROGANTE', value: eroganteChannel.nome },
    ];
    this.cdr.detectChanges();
  }

  private getPersonaGiuridica() {
    let pGRequest$ = this.pgService.getById(
      this.data.pratica.id,
      this.data.pratica.target
    );
    return pGRequest$;
  }
}
